<template>

<div class="center card">
<table class="table table-striped table-hover ">
  <thead>
    <tr>
      <th scope="col">Nº</th>
      <th scope="col">Data</th>
      <th scope="col">Valor</th>
      <th scope="col">Status</th>
    </tr>
  </thead>
  <tbody>

    <tr v-for="pedido in ArrayPedidos.slice().reverse()" :key="pedido.id">
      <th scope="row"># {{ pedido.id }}</th>
      <td><small>{{ pedido.created_at.slice(8,10) }}{{ pedido.created_at.slice(4,8) }} {{ pedido.created_at.slice(0,4) }} </small></td>
      <td><small>R$ {{ pedido.total }}</small></td>
      <th scope="row"> {{ pedido.status.status }} </th>
    </tr>

  </tbody>
</table>
</div>
</template>

<script>
    export default {
        props: {
            ArrayPedidos: {
                type: Array,
            },
        },
        methods: {
        reverse(s){
            return s.split("").reverse().join("");
        }
        },
    }
</script>

<style lang="css" scoped>
.center{
  display: flex;
  align-items: center;
  text-align: center;
}
</style>